import { render, staticRenderFns } from "./SelectParcellesComponent.vue?vue&type=template&id=9fbf2b7c"
import script from "./SelectParcellesComponent.vue?vue&type=script&lang=js"
export * from "./SelectParcellesComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports